"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var utils_1 = require("../utils");
var ConfigProvider_1 = require("../ConfigProvider");
function Divider(props) {
    var _a = props.vertical, vertical = _a === void 0 ? false : _a, _b = props.dashed, dashed = _b === void 0 ? false : _b, classNameFromProps = props.className, style = props.style;
    var prefix = ConfigProvider_1.usePrefix('divider');
    var verticalPrefix = utils_1.concat(prefix, 'vertical');
    var dashPrefix = utils_1.concat(prefix, 'dashed');
    var className = classnames_1.default(prefix, vertical && verticalPrefix, dashed && dashPrefix, classNameFromProps);
    return react_1.default.createElement("div", { className: className, style: style });
}
exports.default = Divider;
//# sourceMappingURL=index.js.map